// extracted by mini-css-extract-plugin
export default {"card6":"AxEX7P3i","image":"ElDIEbaR","content":"jFtqgATw","link":"QnKDEzUQ","altheadline":"cgdcrFFj"};